import React from "react";
import RouterLink from "gatsby-link";
import styled from "styled-components";
import Logo from "./logo";

const Header = () => (
  <StyledHeader>
    <Logo />
    <Menu>
      <MenuItem>
        <Link to="/about">About</Link>
      </MenuItem>
      <MenuItem>
        <Link to="/contact">Contact</Link>
      </MenuItem>
    </Menu>
  </StyledHeader>
);

const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1em;
`;

const Menu = styled.ul`
  list-style-type: none;
  display: flex;
  margin: 0;
  padding: 0;
`;

const MenuItem = styled.li``;

const Link = styled(RouterLink)`
  display: block;
  padding: 1.25em;
  color: var(--black);
  text-decoration: none;
  transition: all 0.25s ease;
  &:hover {
    background-color: white;
  }
`;

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js